import React from 'react';
import userPersonas from '@common/constants/userPersonas';
import Modal from '@common/components/ConstellationV10Modal';
import { Box, Button, Heading, Paragraph, Radio, TextButton } from '@zillow/constellation-10';

type Props = {
  onSubmit: () => void;
  selectedOption: string;
  setSelectedOption: (selectedOption: string) => void;
  onClose: () => void;
  onBack: () => void;
  emergencyMode: boolean;
};

const BusinessTypeSelectorPage: React.FC<React.PropsWithChildren<Props>> = (props: Props): JSX.Element => {
  return (
    <Modal
      persona={userPersonas.LANDLORD}
      onRequestClose={props.emergencyMode ? undefined : props.onClose}
      header={
        <Box css={{ padding: 'token(spacing.sm) !important' }}>
          <TextButton textStyle="body-sm-bold" tone="brand" css={{ float: 'left' }} onClick={props.onBack}>
            Back
          </TextButton>
          <Heading level={3} textStyle="heading-xs" css={{ display: 'flex', justifyContent: 'center' }}>
            Payment setup
          </Heading>
        </Box>
      }
      body={
        <Box
          css={{
            display: 'grid',
            gridTemplateRows: 'auto',
            gap: 'token(spacing.sm) !important',
            padding: 'token(spacing.lg) !important',
          }}
        >
          <Paragraph textStyle="body-lg-bold">How is the business set up?</Paragraph>
          <Paragraph>Choose the specific type of business entity.</Paragraph>
          <Box
            css={{
              display: 'grid',
              gridTemplateColumns: 'auto 1fr',
              gap: 'token(spacing.sm) !important',
            }}
          >
            <Radio
              css={{ margin: '4px' }}
              onChange={() => props.setSelectedOption('single_member_llc')}
              checked={props.selectedOption === 'single_member_llc'}
              value="single_member_llc"
            />
            <Box>
              <Paragraph textStyle="body-bold">Single-member LLC</Paragraph>
              <Paragraph>
                You registered your business with the state, you are the single member, and it&apos;s a separate entity
                for tax purposes.
              </Paragraph>
            </Box>
          </Box>
          <Box
            css={{
              display: 'grid',
              gridTemplateColumns: 'auto 1fr',
              gap: 'token(spacing.sm) !important',
            }}
          >
            <Radio
              css={{ margin: '4px' }}
              onChange={() => props.setSelectedOption('multi_member_llc')}
              checked={props.selectedOption === 'multi_member_llc'}
              value="multi_member_llc"
            />
            <Box>
              <Paragraph textStyle="body-bold">Multi-member LLC or corporation</Paragraph>
              <Paragraph>
                Your business is registered with the state as an LLC or corporation with multiple members.
              </Paragraph>
            </Box>
          </Box>
        </Box>
      }
      footer={
        <Box css={{ padding: 'token(spacing.sm) !important' }}>
          <Button disabled={!props.selectedOption} onClick={props.onSubmit} emphasis="filled">
            Continue
          </Button>
        </Box>
      }
    />
  );
};

export default BusinessTypeSelectorPage;
